import { LocationInterface } from '../Interfaces/LocationInterface';
import * as locationsApi from '../api/locationsApi';
import { StateInterface } from '../Interfaces/StateInterface';
import { sortObjects } from '../utils/utils';
import { initDataPoint } from '../views/SingleInstance/utils/utils';
import { LOCATIONS } from './actionTypes';
import { actionCreator } from './index';
import { autoLogout } from './systemActions';
import { savePOI } from './pois';

export const loadLocations = actionCreator<LocationInterface[]>(LOCATIONS.LOAD);

export const addLocations = actionCreator<LocationInterface[]>(LOCATIONS.ADD_NEW);

export const getLocations = () => {
  return async (dispatch, getState: () => StateInterface) => {
    const { clientPersist } = getState();
    const locations = await locationsApi.getLocations(clientPersist.user_id);
    if (locations && locations.length > 0) {
      dispatch(loadLocations(locations.sort((a, b) => sortObjects(a, b, 'title'))));
    } else {
      dispatch(autoLogout());
    }
  };
};

export const addNewLocation = (locations: Pick<LocationInterface, 'title' | 'level' | 'parent' | 'identifier'>[]) => {
  return (dispatch, getState: () => StateInterface) => {
    const { hierarchy } = getState();
    const promise = locationsApi.addNewLocation(
      hierarchy.id,
      locations.map((l) => {
        return { ...l, location: l.title };
      }),
      dispatch,
      getState,
    );
    promise
      .then((response) => response.json())
      .then((json) => {
        dispatch(
          addLocations(
            json.map((l) => {
              return { ...l, key: l.id, title: l.location };
            }),
          ),
        );

        const state = getState();
        const newLevelZeroLocations = (json as LocationInterface[]).filter((l) => `${l.level}` === '0');
        const seenRefs = new Set<string>();
        const companyForms = state.forms.collection.filter((f) => {
          if (f.crmFormType !== 'company' || seenRefs.has(f.ref)) {
            return false;
          }
          seenRefs.add(f.ref);
          return true;
        });

        for (const form of companyForms) {
          for (const location of newLevelZeroLocations) {
            const dataPoint = initDataPoint(
              { questionnaire_id: form.ref },
              form,
              state.clientPersist,
            );
            dataPoint['Name'] = location.location;
            dataPoint['modified'] = Date.now();
            void dispatch(savePOI(dataPoint, undefined, false));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
